import fina360 from './fina360'
import kiva360 from './kiva360'
import nocfo from './nocfo'
import talousyrittajat from './talousyrittajat'
import tiliviesti from './tiliviesti'

const themes = {
  nocfo,
  kiva360,
  tiliviesti,
  talousyrittajat,
  fina360
}

export const THEME_NAME = import.meta.env.VITE_APP_THEME ?? 'nocfo'
const theme = themes[THEME_NAME as keyof typeof themes]

export default theme
